Ext.define('SA.BasicTable', {
    constructor({el}) {
        this.el = el;
        this.el.classList.add('sa-basic-table');
    },

    getCellAt({rowIndex, columnIndex}) {
        return this.el.rows[rowIndex].cells[columnIndex];
    },

    setRowAndColumnCount({rowCount, columnCount}) {
        var rows = this.el.rows,
            rowDiff = rowCount - rows.length;

        for (let i = 0; i < rowDiff; i++) {
            this.el.insertRow(-1);
        }

        for (let i = (0 - rowDiff); i > 0; i--) {
            this.el.deleteRow(-1);
        }

        Array.from(rows).forEach(row => {
            var cellDiff = columnCount - row.cells.length;

            for (let i = 0; i < cellDiff; i++) {
                row.insertCell(-1);
            }

            for (let i = (0 - cellDiff); i > 0; i--) {
                row.deleteCell(-1);
            }
        });
    }
});